import type { ColumnDef } from '@tanstack/react-table';

import {
    type GetAllRegularTotemClosedDayQuery,
    type TotemClosedDayFragmentFragment,
    TotemClosedDayType,
    TotadminPermission,
} from 'data/__generated__';
import { textColumn, multiSelectColumn } from 'components/DataTable';
import { TotemPrimaryButton } from 'components/TotemPrimaryButton';
import { TOTEM_CLOSED_DAY_TYPE_LABELS } from './types';

export type TotemClosedDayRow = GetAllRegularTotemClosedDayQuery['getAllRegularTotemClosedDay'][number];

type TotemClosedDayFilterInput = {
    searchValue: string;
    type: TotemClosedDayType[];
};

type TotemClosedDayColumnsParams = {
    todayDateFormatted: string;
    archiveLoading: boolean;
    onAbort: (totemClosedDay: TotemClosedDayFragmentFragment) => void;
    onArchive: (totemClosedDayId: string) => void;
};

export const getTotemClosedDaysColumns = ({
    todayDateFormatted,
    archiveLoading,
    onAbort,
    onArchive,
}: TotemClosedDayColumnsParams): ColumnDef<TotemClosedDayRow, unknown>[] => [
    textColumn<TotemClosedDayRow, TotemClosedDayFilterInput>({
        accessorKey: 'date',
        header: 'Date',
        defaultVisible: true,
    }),
    multiSelectColumn<TotemClosedDayRow, TotemClosedDayFilterInput>({
        accessorKey: 'type',
        header: 'Type',
        filterKey: 'type',
        defaultVisible: true,
        options: Object.values(TotemClosedDayType).map((type) => ({
            value: type,
            label: TOTEM_CLOSED_DAY_TYPE_LABELS[type],
        })),
        cell: ({ row }) => TOTEM_CLOSED_DAY_TYPE_LABELS[row.original.type],
    }),
    textColumn<TotemClosedDayRow, TotemClosedDayFilterInput>({
        id: 'abortButton',
        accessorFn: () => '',
        header: 'Annuler',
        defaultVisible: true,
        cell: ({ row }) => (
            <TotemPrimaryButton
                onClick={(e: React.MouseEvent) => {
                    e.stopPropagation();
                    e.preventDefault();
                    onAbort(row.original);
                }}
                disabled={archiveLoading || row.original.date < todayDateFormatted}
                requiredPermissions={[TotadminPermission.TotemsManage]}
            >
                Annuler
            </TotemPrimaryButton>
        ),
    }),
    textColumn<TotemClosedDayRow, TotemClosedDayFilterInput>({
        id: 'archiveButton',
        accessorFn: () => '',
        header: 'Archiver',
        defaultVisible: true,
        cell: ({ row }) => (
            <TotemPrimaryButton
                onClick={(e: React.MouseEvent) => {
                    e.stopPropagation();
                    e.preventDefault();
                    onArchive(row.original._id);
                }}
                disabled={archiveLoading || row.original.date > todayDateFormatted}
                requiredPermissions={[TotadminPermission.TotemsManage]}
            >
                Archiver
            </TotemPrimaryButton>
        ),
    }),
];
